import SeoCategory from '@/pages/seoCategoryListing/index.vue';

export const defaultRoutes = [
  {
    name: 'seo-category-listing',
    path: '/tours/:countrySlug/category/:categorySlug',
    component: SeoCategory,
  },
];
